import { useEffect } from 'react';
import { useLocation, useSearchParams } from 'react-router';
import { useAuthInfo } from '@/routes/_app/use-auth-info.ts';
import { deleteSearchParams } from '@/utils/handle-search-param.ts';
import { getXAuthLink } from '../../utils/get-x-auth-link';

export const useConnectToX = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const xcomParam = params.get('xcom');
  const { username } = useAuthInfo();

  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    if (searchParams.has('xcom'))
      setSearchParams(deleteSearchParams(searchParams, ['xcom']));
  }, [searchParams, setSearchParams]);

  return {
    isAfterConnect: xcomParam === 'true',
    authLink: getXAuthLink(username),
  };
};
